module.exports = __webpack_public_path__ + "img/kanapen.b2fc0a6a.jpg";